import { render } from "./_announcement_notification.vue?vue&type=template&id=44828fae&lang=pug"
import script from "./_announcement_notification.vue?vue&type=script&lang=js"
export * from "./_announcement_notification.vue?vue&type=script&lang=js"

import "./_announcement_notification.vue?vue&type=style&index=0&id=44828fae&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__